import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const knowBe4 = defineConnector({
  identifier: "knowBe4",
  name: "KnowBe4",
  tagLine: "Security awareness training",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.api\\.knowbe4\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [KnowBe4](https://knowbe4.com), go to **Account Settings > API** and create a new API token.",
        },
      ],
    },
    {
      title: "Enter your KnowBe4 details",
      items: [
        {
          kind: "select",
          label: "Region",
          required: true,
          target: { kind: "configuration", field: "region" },
          options: [
            { value: "us.api.knowbe4.com", label: "US" },
            { value: "eu.api.knowbe4.com", label: "EU" },
            { value: "ca.api.knowbe4.com", label: "Canada" },
            { value: "uk.api.knowbe4.com", label: "UK" },
            { value: "de.api.knowbe4.com", label: "Germany" },
          ],
          helperText: "Select the region where your KnowBe4 account is hosted.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ region }) => `https://${region}/v1/account`,
  },
  publicEnvVars: ({ region }) => ({ KNOW_BE4_REGION: region || "" }),
});
